export const SALE_ORDER_TYPE = 'sale_order'
export const PURCHASE_ORDER_TYPE = 'purchase_order'
